import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36238f3e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36238f3e')) {
      api.createRecord('36238f3e', component.options)
    } else {
      api.reload('36238f3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36238f3e&", function () {
      api.rerender('36238f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/index.vue"
export default component.exports